import { useEffect, useRef } from 'react'

export function useDragScroll() {
  const isDragging = useRef(false)
  const startY = useRef(0)
  const startX = useRef(0)
  const scrollStartY = useRef(0)
  const scrollStartX = useRef(0)

  useEffect(() => {
    const handleMouseDown = (e: MouseEvent) => {
      // Don't start drag on interactive elements
      const target = e.target as HTMLElement
      if (
        target.tagName === 'BUTTON' ||
        target.tagName === 'A' ||
        target.closest('button') ||
        target.closest('a') ||
        target.closest('[role="button"]') ||
        target.closest('input') ||
        target.closest('textarea') ||
        target.closest('select')
      ) {
        return
      }

      isDragging.current = true
      startY.current = e.clientY
      startX.current = e.clientX
      scrollStartY.current = window.scrollY
      scrollStartX.current = window.scrollX

      // Add dragging class to body
      document.body.classList.add('dragging')
      
      // Prevent default to avoid text selection
      e.preventDefault()
    }

    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging.current) return

      const deltaY = startY.current - e.clientY
      const deltaX = startX.current - e.clientX

      window.scrollTo({
        top: scrollStartY.current + deltaY,
        left: scrollStartX.current + deltaX,
        behavior: 'auto'
      })

      e.preventDefault()
    }

    const handleMouseUp = () => {
      if (isDragging.current) {
        isDragging.current = false
        document.body.classList.remove('dragging')
      }
    }

    const handleMouseLeave = () => {
      if (isDragging.current) {
        isDragging.current = false
        document.body.classList.remove('dragging')
      }
    }

    // Add event listeners
    document.addEventListener('mousedown', handleMouseDown)
    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
    document.addEventListener('mouseleave', handleMouseLeave)

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleMouseDown)
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
      document.removeEventListener('mouseleave', handleMouseLeave)
      document.body.classList.remove('dragging')
    }
  }, [])
}
